







































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class AddQuestionLoading extends Vue {
  spinnerStyle = {
    backgroundColor: '#F52E00',
    height: '86px',
    width: '6px',
    margin: '7px',
    borderRadius: '200px',
    display: 'inline-block',
    animationName: 'v-scaleStretchDelay',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
    animationFillMode: 'both',
  };
  spinnerDelay1 = {
    animationDelay: '0.1s',
  };
  spinnerDelay2 = {
    animationDelay: '0.2s',
  };
  spinnerDelay3 = {
    animationDelay: '0.3s',
  };
  spinnerDelay4 = {
    animationDelay: '0.4s',
  };
  spinnerDelay5 = {
    animationDelay: '0.5s',
  };
  spinnerDelay6 = {
    animationDelay: '0.6s',
  };
  spinnerDelay7 = {
    animationDelay: '0.7s',
  };
  spinnerDelay8 = {
    animationDelay: '0.8s',
  };
}
